import { clearCustomerBenefits } from "../../utils/customerBenefits";
import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
import { ThemeContext, LanguageContext, UserContext, ActionContext } from "../../contexts/Context";
import axios from "axios";
import { navigate } from "@reach/router";
import { IoCloseOutline, IoLogoInstagram } from "react-icons/io5";
import Modal from "../optioncomponents/Modal";
import CustomerEdit from "./CustomerEdit";
import {
    getAssetUrl,
    getCompanyAddress,
    getCompanyPhone,
    getInstagramInfo,
    getOperatingHours
} from "./loginDisplayUtil";

const formatPointValue = (value) => {
    const numberValue = Number(value);
    if (!Number.isFinite(numberValue)) return "-";
    return Number.isInteger(numberValue) ? `${numberValue}` : numberValue.toFixed(2);
};

const getRewardTypeLabel = (type) => {
    const rewardType = Number(type);
    if (rewardType === 0) return "LOYALTY PTS";
    if (rewardType === 3) return "STAMP";
    return "VOUCHER";
};

const CustomerDetail = ({ show, setShow }) => {
    const [displayShow, setDisplay] = useState(show ? "flex" : "none");
    const [campaign, setCampaign] = useState({});
    const [loyalty, setLoyalty] = useState(0);
    const actions = React.useContext(ActionContext);
    const { addCustomer } = actions;
    const themeContext = React.useContext(ThemeContext);
    const languageContext = React.useContext(LanguageContext);
    const {
        lanIndex, token, customer, pm, cart, finalOrder, company, bgImg, landingImg, otherUrls,
        openingTime, closingTime
    } = React.useContext(UserContext);
    const [availableCampaign, setAvailableCampaign] = useState({});
    const [showEdit, setShowEdit] = useState(false);
    const [processing, setProcessing] = useState(false);
    const [showError, setShowError] = useState(false);
    const [error, setError] = useState([]);

    const submitCustomerEdit = (customer) => {
        if (processing) return;
        if (token) {
            setProcessing(true);
            axios.put(`/v2/api/customer`,
                customer,
                {
                    headers: { Authorization: "Bearer " + token },
                })
                .then(function (response) {
                    setProcessing(false);
                    if (response.status === 200) {
                        setShowEdit(false);
                        addCustomer(response.data.customer);
                        setError([{ errorMessage: "Update Successfully" }]);
                        setShowError(true);
                    }

                })
                .catch(function (error) {
                    setProcessing(false);
                    if (error.response && error.response.status === 402) {
           
                        setError([{ errorMessage: "Phone No has been used" }]);
                        setShowError(true);
                    } else {
                     
                        setError([{ errorMessage: "Something went wrong. Please try again" }]);
                        setShowError(true);
                    }
                })
        }
    };

    useEffect(() => {
        setDisplay(show ? "flex" : "none");
        if (token && show) {
            axios.get(`/v2/api/customer/reward`, {
                headers: { Authorization: "Bearer " + token },
            })
                .then(function (response) {

                    if (response.status === 200) {
                        let nextCampaign = {};
                        for (let c of response.data) {
                            nextCampaign[c._id] = {
                                type: c.type,
                                description: c.rewardTitle,
                                value: c.redeemPts,
                                isValid: false
                            };
                        }
                        setCampaign(nextCampaign);
                    }

                })
                .catch(function (response) {
                    //show warning

                });


        }
        //DUMMY DATA
        // for (let c of reward) {
        //     if (c.type == 0) {
        //         campaign[c._id] = {
        //             type: 0,
        //             description: c.rewardTitle,
        //             value: c.redeemPts,
        //             isValid: loyalty >= c.redeemPts
        //         };
        //     }
        // }
        // setCampaign(JSON.parse(JSON.stringify(campaign)));
    }, [show, token]);

    const customerId = customer && customer._id;
    useEffect(() => {
        if (token && show && customerId) {
            axios.get(`/v2/api/customer/detail?customerId=${customerId}`, {
                headers: { Authorization: "Bearer " + token },
            }).then(function (response) {
                addCustomer(response.data);
            })
        }
    }, [addCustomer, customerId, token, show]);


    useEffect(() => {
        if (!customer) return;
        let availPts = customer.rewardPts - customer.redeemPts - (customer.forfeit ? customer.forfeit : 0);

        setLoyalty(availPts);
        if (Object.keys(campaign).length === 0) return;
        let availCampaign = {};
        if (customer.otherRecords) {
            for (let o of customer.otherRecords) {
                let stampDetail = "";
                if (o.minTrans && o.minTrans > 0 && !isNaN(o.trans))
                    stampDetail = " (" + (o.trans % o.minTrans) + "/" + o.minTrans + ")";
                availCampaign[o._id] = {
                    type: o.type,
                    description: (campaign[o.campaignId] ? campaign[o.campaignId].description : o.title) + stampDetail,
                    value: o.avail - o.redeem - o.forfeit,
                    isValid: o.avail - o.redeem - o.forfeit > 0
                };
            }
        }
        for (let key in campaign) {
            if (Number(campaign[key].type) === 0) {
                availCampaign[key] = {
                    ...campaign[key],
                    isValid: availPts >= campaign[key].value
                };
            }
        }
        setAvailableCampaign(availCampaign);
    }, [customer, campaign]);

    if (!customer) {
        return <></>;
    }

    const topUpBalance = (customer.topUpAmount || 0) - (customer.topUpRedeemAmt || 0);
    const rewardKeys = availableCampaign ? Object.keys(availableCampaign) : [];
    const operatingHours = getOperatingHours(openingTime, closingTime);
    const companyAddress = getCompanyAddress(company);
    const companyPhone = getCompanyPhone(company);
    const instagramInfo = getInstagramInfo(otherUrls);

    const logoutCustomer = () => {
        setShow(false);
        setDisplay("none");
        clearCustomerBenefits({ customer, pm, cart, finalOrder }, actions);

        const currentPath = typeof window !== "undefined" ? window.location.pathname.replace(/\/$/, "") : "";
        const loginPath = token ? `/member/login/${token}` : "/member/login";
        const logoutPath = currentPath === "/member/info" ? loginPath : "/menu";
        navigate(logoutPath);
    };

    return (
        <React.Fragment>
            <DrawerBackdrop
                display={showEdit ? "none" : displayShow}
                onClick={() => {
                    setShow(false);
                    setDisplay("none");
                }}
            />
            <ModalContainer display={showEdit ? "none" : displayShow} bgImg={bgImg} themeContext={themeContext}>
                <IconButton onClick={() => {
                    setShow(false);
                    setDisplay("none");
                }}>
                    <IoCloseOutline size={34} />
                </IconButton>
                <ContentWrapper>
                    <MemberSection>
                        <LogoMark image={company && company.companyLogo} />
                        <HeaderTitle>{languageContext[lanIndex].memberInfo}</HeaderTitle>
                        <Divider />
                        <WelcomeText>WELCOME</WelcomeText>
                        <CustomerName>{`${customer.customerName}`}</CustomerName>
                        <PhoneLine>
                            <PhoneLabel>{languageContext[lanIndex].phone}</PhoneLabel>
                            {`${customer.phone}`}
                        </PhoneLine>
                        <PContainer single={topUpBalance <= 0}>
                            {topUpBalance > 0 &&
                                <PItemContainer>
                                    <Subtitle>{languageContext[lanIndex].topUpAmount}</Subtitle>
                                    <Title>{topUpBalance.toFixed(2)}</Title>
                                </PItemContainer>
                            }
                            <PItemContainer>
                                <Subtitle>{languageContext[lanIndex].loyalty}</Subtitle>
                                <Title>{formatPointValue(loyalty)}</Title>
                                {customer.expiryData && customer.expiryData.date > 0 &&
                                    <ExpiryText>{customer.expiryData.pts}</ExpiryText>
                                }
                            </PItemContainer>
                        </PContainer>
                        <RewardsTitle>AVAILABLE REWARDS</RewardsTitle>
                        <CContainer>
                            {rewardKeys.map((c, i) =>
                                <CampaignWrapper onClick={() => { }}
                                    key={i}
                                    isValid={availableCampaign[c].isValid}>
                                    <CType type={availableCampaign[c].type}>
                                        {getRewardTypeLabel(availableCampaign[c].type)}
                                    </CType>
                                    <RewardContent>
                                        <Description>
                                            {availableCampaign[c].description}
                                        </Description>
                                        <Value>
                                            {formatPointValue(availableCampaign[c].value)}
                                        </Value>
                                    </RewardContent>
                                </CampaignWrapper>
                            )}
                        </CContainer>
                        <Disclaimer>
                            **{languageContext[lanIndex].rewardDisclaimer}**
                        </Disclaimer>
                        <ButtonWrapper>
                            <Button themeContext={themeContext} onClick={() => {
                                setShowEdit(true);
                            }} >
                                {languageContext[lanIndex].edit}
                            </Button>

                            <Button themeContext={themeContext} onClick={logoutCustomer} >
                                {languageContext[lanIndex].logout}
                            </Button>

                        </ButtonWrapper>
                    </MemberSection>
                    {(landingImg || operatingHours || companyPhone || companyAddress || instagramInfo) &&
                        <FooterInfo>
                            {landingImg && <FooterLandingImage image={landingImg} />}
                            {operatingHours && <FooterLine>{operatingHours}</FooterLine>}
                            {companyPhone && <FooterLine>{companyPhone}</FooterLine>}
                            {companyAddress && <FooterAddress>{companyAddress}</FooterAddress>}
                            {instagramInfo && instagramInfo.url &&
                                <InstagramLink href={instagramInfo.url} target="_blank" rel="noopener noreferrer">
                                    <IoLogoInstagram size={46} />
                                    {instagramInfo.handle && <InstagramHandle>{instagramInfo.handle.split("?")[0]}</InstagramHandle>}
                                </InstagramLink>
                            }
                        </FooterInfo>
                    }
                </ContentWrapper>
            </ModalContainer>
            <Modal
                show={showError}
                setShow={setShowError}
                error={error}
                fontFamily={'"contralto-xsmall", sans-serif'}
            />
            <CustomerEdit
                show={showEdit}
                setShow={setShowEdit}
                setShowError={setShowError}
                setError={setError}
                onSubmit={submitCustomerEdit} />

        </React.Fragment >
    );
}

export default CustomerDetail;
const DrawerBackdrop = styled.div`
    display: none;

    @media (min-width: 768px) {
        display: ${(props) => props.display};
        position: fixed;
        inset: 0;
        z-index: 998;
        background: rgba(0, 0, 0, 0.38);
        animation: memberDetailBackdrop 180ms ease-out;

        @keyframes memberDetailBackdrop {
            from { opacity: 0; }
            to { opacity: 1; }
        }
    }
`;

const MemberSection = styled.div`
    width: 100%;
    max-width: 500px;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #2f2f2f;
    text-align: center;
`;

const LogoMark = styled.div`
    width: 118px;
    height: 118px;
    margin-bottom: 12px;
    background-image: ${(props) => props.image ? `url(${getAssetUrl(props.image)})` : "none"};
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;

    @media (max-height: 760px) {
        width: 86px;
        height: 86px;
        margin-bottom: 8px;
    }
`;

const Divider = styled.div`
    width: 100%;
    border-top: 1px solid rgba(68,68,68,0.72);
    margin: 24px 0 22px;

    @media (max-height: 760px) {
        margin: 16px 0 14px;
    }
`;

const WelcomeText = styled.div`
    font-family: "Copperplate", "Times New Roman", serif;
    font-size: 22px;
    font-weight: 600;
    color: #3f3f3f;
    line-height: 1.1;
`;

const CustomerName = styled.div`
    width: 100%;
    margin-top: 18px;
    font-size: 32px;
    font-weight: 300;
    line-height: 1.12;
    color: #3a3a3a;
    word-break: break-word;

    @media (max-width: 390px) {
        font-size: 27px;
    }
`;

const PhoneLine = styled.div`
    margin-top: 10px;
    font-size: 21px;
    font-weight: 600;
    color: #333333;
    line-height: 1.15;
`;

const PhoneLabel = styled.span`
    margin-right: 12px;
    font-family: "Copperplate", "Times New Roman", serif;
`;

const Disclaimer = styled.div`
    width: 100%;
    margin-top: 22px;
    color: #4d4d4d;
    font-size: 13px;
    line-height: 1.25;
`;
const HeaderTitle = styled.div`
    font-size: 30px;
    font-weight: 300;
    line-height: 1;
    letter-spacing: 0;
    color: #404040;
`;
const Subtitle = styled.div`
    color: #646464;
    font-size: 15px;
    font-weight: 300;
    line-height: 1.2;
    text-align: left;
`;
const Title = styled.div`
    margin-top: 6px;
    color: #111111;
    font-size: 27px;
    font-weight: 700;
    line-height: 1;
    text-align: left;
`;
const PItemContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: 86px;
    width: 100%;
    padding: 16px 32px;
    border: 1px solid #c7c7c7;
    border-radius: 14px;
    background: rgba(255,255,255,0.94);
    box-sizing: border-box;
    box-shadow: 0px 1px 2px rgba(0,0,0,0.08);
`;
const PContainer = styled.div`
    display: grid;
    grid-template-columns: ${(props) => props.single ? "minmax(0, 1fr)" : "repeat(2, minmax(0, 1fr))"};
    gap: 12px;
    width: 100%;
    margin-top: 28px;

    @media (max-width: 360px) {
        grid-template-columns: minmax(0, 1fr);
    }
`;
const CContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 12px;
`;
const CampaignWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 112px;
    padding: 18px 26px;
    border-radius: 10px;
    background: rgba(246,247,248,0.96);
    box-sizing: border-box;
    box-shadow: inset 0px 0px 0px 1px rgba(255,255,255,0.7);
    opacity:${(props) => props.isValid ? 1 : 0.4};
`;
const CType = styled.div`
    width: 100%;
    color: ${(props) => Number(props.type) === 0 ? "#7aa7ba" : "#9d8d1c"};
    font-family: "Copperplate", "Times New Roman", serif;
    font-size: 21px;
    font-weight: 600;
    line-height: 1.05;
    text-align: center;
`;
const RewardContent = styled.div`
    display: grid;
    grid-template-columns: minmax(0, 1fr) 44px;
    align-items: center;
    width: 100%;
    margin-top: 10px;
    column-gap: 14px;
`;

const Description = styled.div`
    min-width: 0;
    color: #111111;
    font-size: 25px;
    font-weight: 300;
    line-height: 1.2;
    text-align: center;
    word-break: break-word;

    @media (max-width: 390px) {
        font-size: 22px;
    }
`;
const Value = styled.div`
    color: #111111;
    font-size: 25px;
    font-weight: 700;
    line-height: 1;
    text-align: right;
`;

const ExpiryText = styled.div`
    margin-top: 8px;
    color: #646464;
    font-size: 12px;
    line-height: 1.2;
    text-align: left;
`;

const RewardsTitle = styled.div`
    margin: 48px 0 18px;
    color: #444444;
    font-size: 24px;
    font-weight: 600;
    line-height: 1;
    letter-spacing: 0;
`;
const ButtonWrapper = styled.div`
    display: flex;
    width: 100%;
    justify-content: center;
    gap: 16px;
    margin-top: 18px;
`;
const Button = styled.div`
    display: flex;
    width: 158px;
    max-width: calc(50% - 8px);
    min-height: 48px;
    justify-content: center;
    align-items: center;
    background-color: #5f5f5f;
    color: #ffffff;
    font-size: 21px;
    font-weight: 400;
    border-radius: 25px;
    line-height: 1;
    box-shadow: 0px 2px 5px rgba(0,0,0,0.18);
    cursor: pointer;
`;

const IconButton = styled.div`
  position: absolute;
  right: 20px;
  top: 20px;
  z-index: 99;
  color: #555555;
  cursor: pointer;
`;
const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    min-height: 100dvh;
    padding: 34px 28px 34px;
    gap: 72px;
    box-sizing: border-box;
    overflow-y: auto;

    @media (max-height: 760px) {
        padding-top: 28px;
        gap: 46px;
    }
`;

const FooterInfo = styled.div`
    width: 100%;
    max-width: 520px;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #555555;
    text-align: center;
`;

const FooterLandingImage = styled.div`
    width: 80%;
    height: 100px;
    margin-top: 100px;
    background-image: ${(props) => props.image ? `url(${getAssetUrl(props.image)})` : "none"};
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;

    @media (max-height: 760px) {
        height: 72px;
    }
`;

const FooterLine = styled.div`
    margin-top: 6px;
    font-size: 21px;
    line-height: 1.15;
`;

const FooterAddress = styled.div`
    max-width: 430px;
    margin-top: 10px;
    font-size: 15px;
    font-style: italic;
    line-height: 1.25;
`;

const InstagramLink = styled.a`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    margin-top: 42px;
    color: #555555;
    text-decoration: none;

    @media (max-height: 760px) {
        margin-top: 24px;
    }
`;

const InstagramHandle = styled.div`
    font-family: "contralto-xsmall", sans-serif;
    font-size: 14px;
`;

const ModalContainer = styled.div`
    display: ${(props) => props.display};
    font-family: "contralto-xsmall", sans-serif;
    position: fixed;
    flex-direction: column;
    background-color: ${(props) => props.themeContext.backgroundColor};
    background-image: ${(props) => props.bgImg ? `url(${getAssetUrl(props.bgImg)})` : "none"};
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    top: 0;

    width: 100vw;
    max-width: 550px;
    height: 100dvh;
    z-index: 9;

    animation: modalOrder .1s;
    animation-timing-function: ease-out;
    @keyframes modalOrder {
        0%  {
        transform: translateY(350px);
        opacity: 0;
        }
        
        100%  {
        transform: translateY(0px);
        opacity: 1;
        }
        
    }

    *, input, button, textarea, select {
        font-family: "contralto-xsmall", sans-serif !important;
    }

    @media (min-width: 768px) {
        right: 0;
        left: auto;
        width: min(420px, 92vw);
        max-width: none;
        z-index: 999;
        box-shadow: -14px 0 38px rgba(0, 0, 0, 0.22);
        animation: memberDetailDrawer 220ms cubic-bezier(0.22, 1, 0.36, 1);

        @keyframes memberDetailDrawer {
            from {
                transform: translateX(100%);
                opacity: 0.65;
            }
            to {
                transform: translateX(0);
                opacity: 1;
            }
        }
    }
  `;
